import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { User } from 'mvppoker-portal-common/api'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RegisteringUser {
	credentials?: {
		name: string
		email: string
		password: string
		referral: string
	}
	user?: User
}

const initialState: RegisteringUser = {}

export const registeringUser = createSlice({
	name: 'RegisteringUser',
	initialState,
	reducers: {
		setCredentialsAndUser: (state, action: PayloadAction<RegisteringUser>) => action.payload,
		clearRegisteringUser: () => ({}),
	},
})

export const { setCredentialsAndUser, clearRegisteringUser } = registeringUser.actions

export default registeringUser.reducer
